<template>
  <div class="create-video-standard container">
    <el-form ref="form" :model="form" :rules="rules" size="small">
      <create-choice
        :contentArr="['短视频/图文带货', '通投广告', '专业推广']"
        @onChange="show = true"
      />

      <choose-account title="请选择要推广的商品" type="video" />

      <div class="product">
        <product-selecter :product="product" @onConfirm="onChooseProduct" />
      </div>

      <plan-hosting :form="form" />

      <delivery-setting :form="form" />

      <target-package :form="form" />

      <div style="position: relative">
        <p class="level-1">请为商品添加创意</p>
        <div class="level-2">
          创意类型
          <div class="bulb-wrapper" @click="showCreativeType = true">
            <el-image
              class="icon"
              :src="require('@/assets/images/simulation/icon_bulb.png')"
              fit="cover"
            ></el-image>
            <span class="bulb-text">了解详情</span>
          </div>
        </div>
        <el-radio-group v-model="form.creativeType" size="medium">
          <el-radio-button label="程序化创意" disabled></el-radio-button>
          <el-radio-button label="自定义创意"></el-radio-button>
        </el-radio-group>
        <add-video
          :videoNum="videoNum"
          :videoMax="7"
          :disabled="!!!product"
          :isSearch="true"
          title="添加创意内容"
          rightBtn="根据商品智能生成视频"
          @onConfirm="onConfirm"
        />
        <div class="auto-checkbox">
          <el-checkbox
            v-model="form.moreCreative"
            :disabled="form.creativeType == '自定义创意'"
            >生成更多创意</el-checkbox
          >
        </div>

        <div class="right-lite-video-material">
          <creative-preview :haveVideo="videoNum > 0" />
        </div>
      </div>

      <landing-page :havePorduct="!!product" @backTop="backTop" />

      <div class="switch-bottom">
        <p class="level-2">
          抖音主页隐藏视频
          <el-popover placement="top" trigger="hover">
            <p style="font-size: 12px">
              隐藏后，用户在你的选择的抖音号的主页看不到新增的视频创意
            </p>
            <p style="margin-top: 5px; color: #909399; font-size: 12px">
              注意：计划自动生成的视频创意将默认隐藏，不跟随设置变化
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <el-radio-group v-model="form.hide" size="medium">
          <el-radio-button label="隐藏"></el-radio-button>
          <el-radio-button label="不隐藏"></el-radio-button>
        </el-radio-group>
      </div>

      <creative-label :form="form" :isStandard="true" />

      <form-bottom
        :form="form"
        :show="show"
        @onSubmit="handleRelease"
        @onClose="show = false"
        @onCancel="show = true"
      />
    </el-form>

    <tips-drawer
      :showCreativeType="showCreativeType"
      @onClose="showCreativeType = false"
    />
  </div>
</template>

<script>
import AddVideo from "../components/addVideo.vue";
import ChooseAccount from "../components/chooseAccount.vue";
import createChoice from "../components/createChoice.vue";
import CreativeLabel from "../components/creativeLabel.vue";
import CreativePreview from "../components/creativePreview.vue";
import CustomAudience from "../components/customAudience.vue";
import FormBottom from "../components/formBottom.vue";
import LandingPage from "../components/landingPage.vue";
import PlanHosting from "../components/planHosting.vue";
import ProductSelecter from "../components/productSelecter.vue";
import RightCard from "../components/rightCard.vue";
import TargetPackage from "../components/targetPackage.vue";
import TipsDrawer from "../components/tipsDrawer.vue";
import DeliverySetting from "./deliverySetting.vue";
import { submit } from "@/api/chapterMock";

export default {
  components: {
    createChoice,
    ChooseAccount,
    ProductSelecter,
    PlanHosting,
    DeliverySetting,
    CustomAudience,
    RightCard,
    LandingPage,
    CreativeLabel,
    AddVideo,
    CreativePreview,
    TipsDrawer,
    TargetPackage,
    FormBottom,
  },
  data() {
    var checkBudget = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error("预算不少于300元，不超过9999999.99元，请正确输入")
        );
      }
      if (isNaN(value)) {
        callback(new Error("仅支持输入数字"));
      } else {
        if (value < 300 || value > 9999999.99) {
          callback(
            new Error("预算不少于300元，不超过9999999.99元，请正确输入")
          );
        } else {
          callback();
        }
      }
    };
    var checkBid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("出价不少于0.1元，不超过10000元"));
      }
      if (isNaN(value)) {
        callback(new Error("仅支持输入数字"));
      } else {
        if (value < 0.1 || value > 10000) {
          callback(new Error("出价不少于0.1元，不超过10000元"));
        } else {
          callback();
        }
      }
    };
    return {
      show: false,
      product: null,
      form: {
        planHosting: "关闭",
        hostingStrategy: "优先跑量",
        autoStop: "开启",
        mode: "控成本投放",
        action: "商品购买",
        hide: "隐藏",
        limit: false,
        deliverySpeed: "尽快投放",
        budget: null,
        budgetType: "日预算",
        bid: null,
        directionSetting: "新建定向",
        dateType: "从今天起长期投放",
        startTime: "",
        endTime: "",
        timeIntervalType: "不限",
        adName: "短视频",
        adGroup: "短视频/图文带货-系统默认分组",
        directional: "自定义人群",
        audience: {
          directionalType: "新建定向",
          region: "不限",
          regionArr: [],
          audienceType: "正在该地区的用户",
          sex: "不限",
          age: [],
          interest: "不限",
          behavioralInterest: {
            scene: [],
            day: "30天",
            behaviorArr: [],
            interestArr: [],
          },
          talent: "不限",
          network: [],
          platform: "不限",
          morePopulation: "不限",
          autoExtend: "不启用",
          extendArr: [],
        },
        creativeType: "自定义创意",
        moreCreative: true,
        creativeClass: "",
        creativeLabels: [],
      },
      rules: {
        budget: {
          validator: checkBudget,
          trigger: "blur",
        },
        bid: {
          validator: checkBid,
          trigger: "blur",
        },
      },
      videoNum: 0,
      showCreativeType: false,
    };
  },
  methods: {
    onChooseProduct(val) {
      this.product = val;
    },
    backTop() {
      this.$el.querySelector(".create-choice").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    onConfirm(val) {
      this.videoNum = val;
    },
    // 发布计划
    handleRelease() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm(`确定要提交吗？`)
            .then(() => {
              const classChapterId = localStorage.getItem("mockChapterId");
              submit({
                classChapterId,
                content: JSON.stringify({
                  ...this.form,
                  ...JSON.parse(this.$route.query.form),
                }),
              }).then((res) => {
                this.$alert("提交成功", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    window.close();
                  },
                });
              });
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.create-video-standard {
  padding-top: 32px;
  padding-left: 50px;
  text-align: left;
  .level-1 {
    margin-top: 56px;
    line-height: 34px;
    font-weight: 500;
    font-size: 24px;
    color: #111;
  }
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }
  .product {
    margin-top: 24px;
    width: 648px;
  }
  ::v-deep .t-input {
    width: 400px;
    .el-input__inner {
      background-color: #f2f2f2;
    }
    .el-input__count-inner {
      background: #f2f2f2;
    }
  }
  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 15px;
      padding-right: 15px;
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;
      // border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
  .bulb-wrapper {
    display: inline-block;
    margin-left: 5px;
    cursor: pointer;
    &:hover {
      .bulb-text {
        visibility: visible;
        opacity: 1;
      }
    }
    .icon {
      vertical-align: -5px;
    }
    .bulb-text {
      display: inline-block;
      padding-right: 8px;
      font-size: 12px;
      font-weight: 400;
      line-height: 26px;
      color: #ee8c10;
      height: 26px;
      border-radius: 19px;
      overflow: hidden;
      background: radial-gradient(
          42.91% 103.85% at 82.93% -23.08%,
          rgba(255, 126, 71, 0.15) 0,
          hsla(0, 0%, 100%, 0) 100%
        ),
        linear-gradient(
          268.85deg,
          #fef7d8 23.21%,
          rgba(254, 247, 216, 0) 99.01%
        );
      vertical-align: middle;
      transition: all 0.3s ease;
      visibility: hidden;
      opacity: 0;
    }
  }
  .auto-checkbox {
    margin-top: 10px;
    ::v-deep .el-checkbox {
      &.is-disabled {
        opacity: 0.5;
      }
      .el-checkbox__inner {
        width: 16px;
        height: 16px;
        &:hover {
          border-color: #333;
        }
        &::after {
          left: 5px;
        }
      }
      .el-checkbox__label {
        padding-left: 5px;
        line-height: 20px;
        font-size: 14px;
        font-weight: bold;
        color: #333;
      }
      &.is-checked {
        .el-checkbox__inner {
          background-color: #333;
          border-color: #333;
        }
        .el-checkbox__label {
          color: inherit;
        }
      }
      .el-checkbox__input.is-focus {
        .el-checkbox__inner {
          border-color: #333;
        }
      }
    }
  }
  .right-lite-video-material {
    position: absolute;
    top: 0;
    right: calc((100vw - 1200px) / 2);
  }
}
</style>